export enum ChartTimeRangesEnum {
    Week = 1,
    MonthToDate,
    Month,
    YearToDate,
    Year
}
